import { PluginListenerHandle, registerPlugin } from '@capacitor/core';

export interface HgmDarkModePlugin {
    isDarkMode(): Promise<{ dark: boolean }>;
    addListener(eventName: 'darkModeChange', listenerFunc: (data: { dark: boolean }) => void): Promise<PluginListenerHandle>;
}

// Bridged to the in-app HgmDarkModePlugin Java class registered in MainActivity.
// Android-only: callers must gate calls on isAndroid().
export const HgmDarkMode = registerPlugin<HgmDarkModePlugin>('HgmDarkMode');
